import { render, staticRenderFns } from "./SettleCertList.vue?vue&type=template&id=bb8336f4&scoped=true"
import script from "./SettleCertList.vue?vue&type=script&lang=js"
export * from "./SettleCertList.vue?vue&type=script&lang=js"
import style0 from "./SettleCertList.vue?vue&type=style&index=0&id=bb8336f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8336f4",
  null
  
)

export default component.exports